// extracted by mini-css-extract-plugin
export var CircleLoader = "index-module--CircleLoader--1016c";
export var Small = "index-module--Small--9f8f8";
export var loaderSpin = "index-module--loaderSpin--fd9e1";